import { render } from "./ViewUserPage.vue?vue&type=template&id=33d3f3ee&lang=html"
import script from "./ViewUserPage.vue?vue&type=script&lang=js"
export * from "./ViewUserPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__